import { Documents } from '@/types/company';
import { TFunction, t } from 'i18next';
interface DocumentServiceConstructor {
  t: TFunction<'appNS', undefined, 'appNS'>;
}
export class DocumentService {
  private t: TFunction<'appNS', undefined, 'appNS'>;

  constructor(invoiceStatus: DocumentServiceConstructor) {
    this.t = invoiceStatus.t;
  }

  public signingErrorMessagesMapper: Partial<
    Record<Documents.SignDocumentErrorCodes, string>
  > = {
    phone_no_error: t('phone_number_is_not_correct'),
    personal_no_error: t('personal_number_is_not_correct'),
    verification_method_error: t('verification_method_is_not_correct'),
  };
}
